"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migrateToNewPalette = exports.paletteMap = void 0;
exports.paletteMap = {
    '#272d37': '#2c2c2c',
    '#3f3f3f': '#545454',
    '#595959': '#545454',
    '#d8d8d8': '#c9c9c9',
    '#f2f2f2': '#f1f1f1',
    '#e2e7f4': '#f7f7f7',
    '#7030a0': '#6A1B9A',
    '#c00000': '#f56b62',
    '#ff0000': '#f56b62',
    '#f6a1c9': '#f8a4be',
    '#f272af': '#f8a4be',
    '#738ac8': '#6F81CC',
    '#aab8de': '#afb8e1',
    '#b3bcca': '#d0d5ed',
    '#c7d0e9': '#d0d5ed',
    '#e5f5d7': '#e2efd2',
    '#fad0e4': '#CFE5B4',
    '#00192e': '#233591',
    '#0070c0': '#0277BD',
    '#007dea': '#3d5afe',
    '#00addc': '#00ADEE',
    '#00b0f0': '#2CC3F8',
    '#60b5ff': '#5dcef9',
    '#8be6ff': '#91dcfb',
    '#d9dde4': '#91dcfb',
    '#c5f2ff': '#bfeafd',
    '#d6ecff': '#beeef5',
    '#c9f7f1': '#beeef5',
    '#51d9ff': '#00b9cc',
    '#5fe7d5': '#24cfe1',
    '#94efe3': '#5ad8e7',
    '#cbecb0': '#e2efd2',
    '#c58c00': '#f48100',
    '#feb80a': '#FE9E00',
    '#835d00': '#ffa800',
    '#ffc000': '#FFD233',
    '#fee29c': '#ffd592',
    '#fed46b': '#ffd592',
    '#fef0cd': '#ffe5bf',
    '#ffff00': '#FFF9C4',
    '#2c3f71': '#233591',
    '#003e75': '#01579b',
    '#00566e': '#01579b',
    '#0081a5': '#00a7b6',
    '#425ea9': '#5068c2',
    '#3f6c19': '#388d41',
    '#b2e389': '#9ccc65',
    '#92d050': '#9CCC65',
    '#7fd13b': '#98efa4',
    '#00b050': '#5AB963',
};
function migrateToNewPalette(hexCode) {
    var white = '#ffffff';
    var newHex = exports.paletteMap[hexCode];
    return newHex ? newHex : hexCode ? hexCode : white;
}
exports.migrateToNewPalette = migrateToNewPalette;
